import {
    Outlet,
    useOutletContext,
} from 'react-router-dom';
import {
    FetchError,
    Loading,
} from '../../../components';
import {useQuery} from '../../../hooks';
import {
    Endpoint,
    extractErrorMessage,
} from '../../../util';

export function TestReorderContext() {
    const outletContext = useOutletContext();
    const {
        data: currentUserProfile = {},
        error,
        isError,
        isPending,
    } = useQuery({endpoint: Endpoint.PROFILE});

    if (isPending) {
        return <Loading />;
    }

    if (isError) {
        return <FetchError reason={extractErrorMessage(error)} />;
    }

    return (
        <Outlet
            context={{
                ...outletContext,
                currentUserProfile,
            }}
        />
    );
}
